<template>
    <section class="section">
        <div class="container pa-2">
            <h2 class="is-size-3 has-text-weight-bold is-family-secondary mx-3 has-text-centered" :style="computedFont">Prêmios</h2>

            <div class="cp-line-lh mx-6 my-2 columns is-flex is-centered" :style="computedPrimary"></div>

            <p class="is-family-secondary mx-3 has-text-centered">Se cadastre e acesse nosso site para conhecer todos os prêmios disponíveis no programa.</p>

            <div class="columns">
                 <div class="column" v-for="(prize, index) in prizes" :key="index">
                    <figure 
                    class="columns is-flex is-centered mt-6"
                    v-if="prize.photo_url">
                        <img class="image is-128x128"
                            :src="prize.photo_url"
                            :alt="prize.name"
                        />
                    </figure>

                     <div>
                        <p class="cp-title-5 has-text-centered my-4">{{ prize.name }}</p>
                    </div>

                    <div>
                        <div class="has-text-justify mx-6">{{ prize.description }}</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            styles: 'company/landing_page_colors',
            prizes: 'prizes/prizes'
        }),
        computedFont() {
            return {
                'color': this.styles.title_color,
            }
        },
         computedPrimary(){
            return {
                'background-color': this.styles.title_color,
            }
        },
    }
}
</script>

<style scoped>
.container{
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>